import { func } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ArchiveButton from 'calendar/components/ArchiveButton';
import Highlights from 'calendar/components/AtgHighlights';
import CalendarList from 'calendar/components/CalendarList';
import Heading from 'calendar/components/Heading';
import JokerwizButton from 'calendar/components/JokerwizButton';
import ToggleVisibilityButton from 'calendar/components/ToggleVisibilityButton';
import {
  changeAtgListVisibility,
  changeAtgSectionVisibility,
  fetchAtgCalendar,
} from 'calendar/redux/actions';
import { calendar } from 'calendar/redux/selectors';
import ErrorInfo from 'shared/components/ErrorInfo';
import { user } from 'shared/redux/selectors';
import { getText } from 'shared/utils/Text';

const mapStateTopProps = state => ({
  isLoggedIn: user.isLoggedIn(state),
  calendar: calendar.getAtgCalendar(state),
  error: calendar.getAtgCalendarError(state),
  hasCalendar: calendar.hasAtgCalendar(state),
  highlights: calendar.getAtgCalendarHighlights(state),
  showSection: calendar.isAtgSectionVisible(state),
  showList: calendar.isAtgListVisible(state),
  hasSubscription: user.hasSubscription(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchAtgCalendar,
      changeAtgSectionVisibility,
      changeAtgListVisibility,
    },
    dispatch,
  );

export default connect(
  mapStateTopProps,
  mapDispatchToProps,
)(
  class AtgContainer extends Component {
    static propTypes = {
      onCreateBet: func.isRequired,
      onShowArchive: func.isRequired,
    };

    componentDidMount() {
      const { fetchAtgCalendar, showSection } = this.props;
      if (showSection) {
        fetchAtgCalendar();
      }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      // Fetch the calendar when the section becomes visible
      if (!this.props.showSection && nextProps.showSection) {
        nextProps.fetchAtgCalendar();
      }
    }

    toggleSectionVisibility = () => {
      const { showSection, changeAtgSectionVisibility } = this.props;
      changeAtgSectionVisibility(!showSection);
    };

    toggleListVisibility = () => {
      const { showList, changeAtgListVisibility } = this.props;
      changeAtgListVisibility(!showList);
    };

    render() {
      const {
        isLoggedIn,
        showSection,
        showList,
        calendar,
        hasCalendar,
        error,
        highlights,
        onCreateBet,
        onShowArchive,
        onShowJokerWiz,
        hasSubscription,
      } = this.props;
      return (
        <section>
          <Heading
            title={getText('calendar-atgtitle')}
            subTitle={getText('calendar-atg-subtitle')}
            showSectionVisibilityButton
            isSectionVisible={showSection}
            sectionVisibilityButtonLabel={getText(
              'calendar-atg-section-toggle',
            )}
            onSectionVisibiltyChange={this.toggleSectionVisibility}
          />
          {showSection && (
            <JokerwizButton
              onClick={onShowJokerWiz}
              upgradeRequired={isLoggedIn && !hasSubscription}
            />
          )}
          {showSection && (
            <ArchiveButton
              label={getText('calendar-archive-button-atg')}
              enabled={isLoggedIn}
              onClick={onShowArchive}
            />
          )}
          {showSection && (
            <Highlights
              highlights={highlights}
              loading={!hasCalendar}
              onItemClick={onCreateBet}
            />
          )}
          {showSection && (
            <ToggleVisibilityButton
              visible={showList}
              label={getText('calendar-atg-list-toggle')}
              onClick={this.toggleListVisibility}
            />
          )}
          {showSection && showList && (
            <CalendarList
              calendar={calendar}
              loading={!hasCalendar}
              onItemClick={onCreateBet}
              variant="ATG"
            />
          )}
          {error && <ErrorInfo error={error} />}
        </section>
      );
    }
  },
);
